import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Container, Button } from '@material-ui/core';
import { ImageWrapper } from '../Home/Sections/Steps/Steps.styles';

export const StyledContainer = styled(Container)`
    && {
        max-width: 940px;
    }
`;

export const BackButton = styled(Button)`
    && {
        color: ${({ theme }) => theme.colors.primary};
        font-size: 10px;
        font-weight: bold;
        padding: 0;
        margin-bottom: ${({ theme }) => theme.spacing * 6}px;
        .MuiButton-startIcon {
            transform: rotate(180deg);
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export const Description = styled.p`
    margin: ${({ theme }) => theme.spacing * 6}px 0 0;
    color: ${({ theme }) => theme.colors.grayAlpha};
    line-height: 28px;
`;

export const Item = styled.div`
    width: 300px;
    height: 100px;
    box-sizing: border-box;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.darkBlueAlpha};
    display: flex;
    align-items: center;
    > h3 {
        margin: 0;
        font-size: 24px;
        color: ${({ theme }) => theme.colors.gray};
        opacity: .87;
    }
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 300px);
    grid-gap: ${({ theme }) => theme.spacing * 6}px;
    margin: ${({ theme }) => theme.spacing * 10}px 0 0;
    @media screen and (max-width: 960px) {
        grid-template-columns: repeat(2, 300px);
        justify-content: center;
    }
    @media screen and (max-width: 690px) {
        grid-template-columns: 100%;
        justify-content: center;
    }
`;

export const Image = styled.div`
    width: 380px;
    height: 380px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.gray};
    margin-top: ${({ theme }) => theme.spacing * 6}px;
    @media screen and (max-width: 960px) {
        display: none;
    }
`;

export const SmallItem = styled(Item)`
    width: 220px;
    height: 106px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    > p {
        margin: 0;
        font-weight: bold;
        color: #3333338a;
        line-height: 24px;
    }
    > h3 {
        line-height: 32px;
    }
    @media screen and (max-width: 690px) {
        width: 100%;
        margin-bottom: ${({ theme }) => theme.spacing * 4}px;
    }
`;

export const GridContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 460px 380px;
    justify-content: space-between;
    @media screen and (max-width: 960px) {
        grid-template-columns: 100%;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: ${({ theme }) => theme.spacing * 8}px;
    @media screen and (max-width: 690px) {
        flex-direction: column;
    }
`;

export const SectionWrapper = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing * 25}px;
`;

export const OffersWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-gap: ${({ theme }) => theme.spacing * 12}px 
        ${({ theme }) => theme.spacing * 8}px;
    margin-top: ${({ theme }) => theme.spacing * 15}px;
    @media screen and (max-width: 690px) {
        grid-template-columns: 100%;
    }
`;

export const OfferWrapper = styled.div`
    display: grid;
    grid-template-columns: 40px auto;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
    > div {
        > h3 {
            font-size: 16px;
            line-height: 24px;
            color: ${({ theme }) => theme.colors.gray};
            opacity: .87;
            margin: 0;
        }
        > p {
            margin: 0;
            font-size: 14px;
            color: ${({ theme }) => theme.colors.grayAlpha};
            line-height: 26px;
        }
    }
`;

export const CostWrapper = styled.div`
    margin-top: ${({ theme }) => theme.spacing * 12}px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    > div {
        color: #254569;
        text-align: center;
        > h1 {
            margin: 0;
            font-size: 32px;
            line-height: 39px;
        }
        > p {
            margin: 0;
            font-weight: bold;
            line-height: 19px;
        }
    }
    @media screen and (max-width: 690px) {
        flex-direction: column;
        height: auto;
        padding: 24px;
    }
`;

export const Divider = styled.div`
    height: 100%;
    width: 30px;
    position: relative;
    > div {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 2px;
        background-color: #0070db1a;
        height: 100%;
    }
    > span {
        width: 30px;
        height: 40px;
        line-height: 40px;
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        text-align: center;
        color: #254569;
        background-color: ${({ theme }) => theme.colors.paleBlue};
        font-size: 16px;
        font-weight: bold;
        font-style: italic;
    }

    @media screen and (max-width: 690px) {
        height: 30px;
        width: 100%;
        margin: ${({ theme }) => theme.spacing * 6}px 0;
        > div {
            width: 100%;
            height: 2px;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
        > span {
            width: 40px;
            height: 30px;
            line-height: 30px;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
`;

export const StyledButton = styled(Link)`
    width: 200px;
    height: 44px;
    border: none;
    border-radius: 6px;
    outline: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.white};
    text-transform: uppercase;
    background-color: ${({ theme }) => theme.colors.blue};
    display: block;
    margin: ${({ theme }) => theme.spacing * 12}px auto;
    text-align: center;
    line-height: 44px;
    text-decoration: none;
`;

export const StyledImageWrapper = styled(ImageWrapper)`
    margin-top: ${({ theme }) => theme.spacing * 7}px;
    @media screen and (max-width: 1280px) {
        display: none;
    }
`;

export const DisabledButton = styled.button`
    width: 200px;
    height: 44px;
    border: none;
    border-radius: 6px;
    outline: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.white};
    text-transform: uppercase;
    background-color: ${({ theme }) => theme.colors.blue};
    display: block;
    margin: ${({ theme }) => theme.spacing * 12}px auto;
    text-align: center;
    line-height: 44px;
    text-decoration: none;
`;
